import { Button, Checkbox, Input, ListItemText, MenuItem, Pagination, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { useState, useEffect, useRef } from 'react'
import { ApiFindDepartment } from 'utils/api/data'
import { ApiDiseaseDetail, ApiDiseaseGraph, ApiExportExcel, ApiFindDropdown } from 'utils/api/analytics'
import ChartDisease from '../chart/bar-disease-group'


function Index() {

  const [year, setYear] = useState([])
  const [optionYear, setOptionYear] = useState([])

  const [department, setDepartment] = useState('all')
  const [optionDepartment, setOptionDepartment] = useState([])

  const [compare, setCompare] = useState('compare-bmi')
  const [riskgroup, setRiskgroup] = useState([])
  const [optionRiskgroup, setOptionRiskgroup] = useState(['น้ำหนักต่ำกว่าเกณฑ์', 'สมส่วน', 'น้ำหนักเกิน', 'โรคอ้วน', 'โรคอ้วนอันตราย'])
  const [group, setGroup] = useState('group_bmi')
  const [condition, setCondition] = useState(false) //ไต ตับ เอาไว้เปิดปิดกลุ่มเสี่ยง

  const [exportData, setExportData] = useState('null')
  const chartRef = useRef(null)
  const chartRefNcds = useRef(null)

  const [findGraph, setFindGraph] = useState(null)
  const [findDetail, setFindDetail] = useState([])

  const [findGraphNCDs, setFindGraphNCDs] = useState(null)
  const [findDetailNCDs, setFindDetailNCDs] = useState([])

  const [totalAll, setTotalAll] = useState(0)
  const [headerKey, setHeaderKey] = useState([])
  const [page, setPage] = useState(1)
  const [maxPage, setMaxPage] = useState(1)
  const handlePageChange = (event, page) => {
    setPage(page)
  }

  const [totalNcds, setTotalNcds] = useState(0)
  const [headerKeyNCDs, setHeaderKeyNCDs] = useState([])
  const [pageNCDs, setPageNCDs] = useState(1)
  const [maxPageNCDs, setMaxPageNCDs] = useState(1)
  const handlePageChangeNCDs = (event, page) => {
    setPageNCDs(page)
  }

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const lastThreeYears = [currentYear, currentYear - 1, currentYear - 2].map(String);
    setYear(lastThreeYears)

    fetchData()
  }, [])

  useEffect(() => {
    fetchDiseaseGraph()
  }, [compare, year, department, riskgroup])
  useEffect(() => {
    fetchDiseaseDetail()
  }, [compare, year, department, page, riskgroup])

  useEffect(() => {
    fetchDiseaseGraphNCDs()
  }, [year, department])
  useEffect(() => {
    fetchDiseaseDetailNCDs()
  }, [year, department, pageNCDs])

  const fetchData = async () => {
    ApiFindDropdown('year').then(res => {
      if (res.status) {
        setOptionYear(res.data)
      } else {
        setOptionYear([])
      }
    })

    ApiFindDepartment({ doc_status: 'W' }).then(res => {
      if (res && res.length > 0) {
        setOptionDepartment(res)
      } else {
        setOptionDepartment([])
      }
    })
  }

  const fetchDiseaseGraph = async () => {
    ApiDiseaseGraph(compare, year, department === 'all' ? null : department, riskgroup.length == 0 ? null : group, riskgroup.length == 0 ? null : riskgroup).then(res => {
      if (res.status) {
        setFindGraph(res.data)
      } else {
        setFindGraph([])
      }
    })
  }
  const fetchDiseaseDetail = async () => {
    ApiDiseaseDetail(compare, year, department === 'all' ? null : department, page, riskgroup.length == 0 ? null : group, riskgroup.length == 0 ? null : riskgroup).then(res => {
      if (res.status) {
        let data = res.data
        setFindDetail(data['data'])

        const key = getValueAndResultKeys(data['data']);
        setHeaderKey(key)

        setPage(data.pagging.page)
        setMaxPage(data.pagging.totalPage)
        setTotalAll(data.pagging.total)
      } else {
        setFindDetail([])
        setPage(1)
        setMaxPage(1)
        setTotalAll(0)
      }
    })
  }

  const fetchDiseaseGraphNCDs = async () => {
    ApiDiseaseGraph('compare-ncds', year, department === 'all' ? null : department).then(res => {
      if (res.status) {
        setFindGraphNCDs(res.data)
      } else {
        setFindGraphNCDs([])
      }
    })
  }
  const fetchDiseaseDetailNCDs = async () => {
    ApiDiseaseDetail('compare-ncds', year, department === 'all' ? null : department, page).then(res => {
      if (res.status) {
        let data = res.data
        setFindDetailNCDs(data['data'])

        const key = getValueAndResultKeys(data['data']);
        setHeaderKeyNCDs(key)

        setPageNCDs(data.pagging.page)
        setMaxPageNCDs(data.pagging.totalPage)
        setTotalNcds(data.pagging.total)
      } else {
        setFindDetailNCDs([])
        setPageNCDs(1)
        setMaxPageNCDs(1)
        setTotalNcds(0)
      }
    })
  }

  const getValueAndResultKeys = (dataArray) => {
    const keySet = new Set();
    dataArray.forEach(obj => {
      Object.keys(obj).forEach(key => {
        if (key.includes('value_') || key.includes('result_')) {
          keySet.add(key);
        }
      });
    });
    return Array.from(keySet);
  };

  const handleChange = (type, e) => {
    if (type === 'year') {
      setYear(e.target.value)
    } else if (type === 'department') {
      setDepartment(e.target.value)
    }
  }

  const handleChangeOptionFilter = (value) => {
    setCondition(false)
    setGroup('')
    setRiskgroup([])

    setCompare(value)
    switch (value) {
      // case "compare-ncds":
      //   setOptionRiskgroup(['ปกติ', 'เสี่ยง', 'เป็นโรค'])
      //   break;
      case "compare-bmi":
        setOptionRiskgroup(['น้ำหนักต่ำกว่าเกณฑ์', 'สมส่วน', 'น้ำหนักเกิน', 'โรคอ้วน', 'โรคอ้วนอันตราย'])
        setGroup('group_bmi')
        break;
      case "compare-blood-pressure":
        setOptionRiskgroup(['ปกติ', 'เสี่ยง', 'ผิดปกติ', 'พบแพทย์ด่วน', 'ต่ำกว่าเกณฑ์'])
        setGroup('group_bps')
        break;
      case "compare-blood-sugar":
        setOptionRiskgroup(['ปกติ', 'เสี่ยง', 'ผิดปกติ', 'พบแพทย์ด่วน'])
        setGroup('group_fbs')
        break;
      case "compare-total-cholesterol":
        setOptionRiskgroup(['ปกติ', 'เสี่ยง', 'ผิดปกติ'])
        setGroup('group_chol')
        break;
      case "compare-triglycerides":
        setOptionRiskgroup(['ปกติ', 'เสี่ยง', 'ผิดปกติ', 'พบแพทย์ด่วน'])
        setGroup('group_trig')
        break;
      case "compare-ldl":
        setOptionRiskgroup(['ปกติ', 'เสี่ยง', 'ผิดปกติ', 'พบแพทย์ด่วน'])
        setGroup('group_ldl')
        break;
      case "compare-hdl":
        setOptionRiskgroup(['ต่ำ', 'สูง'])
        setGroup('group_hdl')
        break;
      case "compare-liver":
        // setOptionRiskgroup(['ปกติ', 'ผิดปกติ', 'พบแพทย์ด่วน'])
        // setGroup('group_liver')
        setCondition(true)
        setOptionRiskgroup([])
        break;
      case "compare-kidney":
        // setOptionRiskgroup(['ปกติ', 'ผิดปกติ'])
        // setGroup('group_kidney')
        setCondition(true)
        setOptionRiskgroup([])
        break;
      case "compare-x-ray":
        setOptionRiskgroup(['ปกติ', 'ผิดปกติ'])
        setGroup('group_x_ray')
        break;
      default:
        console.log("default");
    }
  }

  const handleClickExport = (type) => {
    if (type === 'ncds') {
      let data = {
        "compare_by_disease": 'compare-ncds',
        "year": year.join(','),
        "department_code": department === 'all' ? null : department,
        "export_file_name": "excel-compare-ncds",
        "export_sheet_name": "excel-compare-ncds"
      }
      // console.log(data)
      exportExcel(data)
    } else {
      let data = {
        "compare_by_disease": compare,
        "year": year.join(','),
        "department_code": department === 'all' ? null : department,
        "export_file_name": `excel-` + compare,
        "export_sheet_name": `excel-` + compare
      }
      // console.log(data)
      exportExcel(data)
    }
  }

  const exportExcel = async (data) => {
    ApiExportExcel(data).then(res => {
      if (res.status) {
        window.open(res.data.file_url)
      } else {
        alert(res.message)
      }
    })
  }

  const handleClickExportData = (value, type) => {
    if (value == 'EXCEL') {
      handleClickExport(type)
    } else if (value == 'PNG') {
      if (type === 'ncds') {
        chartRefNcds.current?.downloadPNG();
      } else {
        chartRef.current?.downloadPNG();
      }
    }
  }

  return (
    <>
      <Box sx={{
        backgroundColor: '#FFFFFF',
        padding: '10px',
      }}>

        <Box sx={{
          display: 'grid',
          gridGap: '20px'
        }}>
          <Box sx={{
            display: 'flex',
            gridGap: '20px'
          }}>
            <Box>
              <Box sx={{ fontWeight: 600 }}>เลือกปีงบประมาณ (สูงสุด 3 ปี)</Box>
              <Select
                size="small"
                fullWidth
                sx={{ ...SelectCss }}
                multiple
                value={year}
                onChange={(e) => {
                  const { value } = e.target
                  setYear(value)
                }}
                // renderValue={(selected) => selected.join(', ')}
                renderValue={(selected) => {
                  const selectedLabels = selected.map((code) => {
                    const found = optionYear.find((y) => y.i_code === code);
                    return found ? found.i_name : code;
                  });
                  return selectedLabels.join(', ');
                }}
              >
                <MenuItem value={'null'} disabled>เลือกปี</MenuItem>
                {optionYear.map((i, idx) => (
                  <MenuItem key={idx} value={i["i_code"]}>
                    <Checkbox checked={year.indexOf(i["i_code"]) > -1} />
                    <ListItemText primary={i["i_name"]} />
                  </MenuItem>
                ))}
              </Select>
            </Box>
            <Box>
              <Box sx={{ fontWeight: 600 }}>เลือกสังกัด</Box>
              <Select
                size="small"
                fullWidth
                sx={{ ...SelectCss }}
                value={department || 'null'}
                onChange={(e) => { handleChange('department', e) }}
              >
                <MenuItem value={'null'} disabled>เลือกสังกัด</MenuItem>
                <MenuItem value={'all'}>ทั้งหมด</MenuItem>
                {optionDepartment.map((d, idx) => (
                  <MenuItem key={idx} value={d.department_code}>{d.department_name}</MenuItem>
                ))}
              </Select>
            </Box>
          </Box>

          <Box sx={{
            border: '1px solid #478F96',
            borderRadius: '10px'
          }}>
            <ChartDisease
              ref={chartRefNcds}
              title={'compare-ncds'}
              data={findGraphNCDs?.['group_year'] ? findGraphNCDs?.['group_year'] : []}
              color={findGraphNCDs?.['color'] ? findGraphNCDs?.['color'] : null}
            />
          </Box>

          <Box>
            {/* <Button
              variant='contained'
              sx={{
                backgroundColor: '#C8EBEB',
                boxShadow: 'none',
                color: '#263238'
              }}
              onClick={() => handleClickExport('ncds')}
            >Export raw data</Button> */}
            <Select
              size="small"
              sx={{ ...SelectCss }}
              value={exportData || 'null'}
              onChange={(e) => handleClickExportData(e.target.value, 'ncds')}
            >
              <MenuItem value={'null'} disabled>Export</MenuItem>
              <MenuItem value={'EXCEL'} >EXCEL</MenuItem>
              <MenuItem value={'PNG'} >PNG</MenuItem>
            </Select>
          </Box>

          <Box sx={{
            overflow: 'auto'
          }}>
            <TableContainer sx={{ maxHeight: '700px' }}>
              <Table sx={{ minWidth: '1200px' }}>
                <TableHead sx={{ backgroundColor: '#C8EBEB' }}>
                  <TableRow>
                    <TableCell align='center' sx={{ minWidth: '220px' }}>ชื่อ-นามสกุล</TableCell>
                    <TableCell align='center' sx={{ minWidth: '180px' }}>เลขบัตรประชาชน</TableCell>
                    <TableCell align='center'>อายุ</TableCell>
                    <TableCell>สังกัด</TableCell>
                    {headerKeyNCDs.map((key, idx) => (
                      <TableCell key={idx}>{key}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {findDetailNCDs.length > 0 ? (
                    findDetailNCDs.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell>{item['full_name']}</TableCell>
                        <TableCell align='center'>{item['pid']}</TableCell>
                        <TableCell align='center'>{item['age']}</TableCell>
                        <TableCell>{item['department_name_short']}</TableCell>
                        {headerKeyNCDs.map((key, idx) => (
                          <TableCell key={idx}>{item[key] && item[key].trim() !== '' ? item[key] : '-'}</TableCell>
                        ))}
                      </TableRow>
                    ))
                  )
                    :
                    (
                      <TableRow>
                        <TableCell colSpan='6'>
                          <Box sx={{ textAlign: 'center' }}>ไม่มีข้อมูล</Box>
                        </TableCell>
                      </TableRow>
                    )
                  }
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          <Box sx={{
            display: 'flex',
            // justifyContent: 'end',
            justifyContent: 'space-between',
            margin: 2
          }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>จำนวนรวม = {totalNcds} คน</Typography>
            <Stack spacing={2}>
              <Pagination
                count={maxPageNCDs}
                page={pageNCDs}
                onChange={handlePageChangeNCDs}
                shape="rounded"
                color="primary"
              />
            </Stack>
          </Box>
        </Box>

        <Box sx={{
          display: 'grid',
          gridGap: '20px'
        }}>
          <Box sx={{
            display: 'flex',
            gridGap: '20px'
          }}>
            <Box>
              <Box sx={{ fontWeight: 600 }}>เลือกรายการตรวจอื่น ๆ</Box>
              <Select
                size="small"
                fullWidth
                sx={{ ...SelectCss }}
                value={compare || 'null'}
                onChange={(e) => {
                  handleChangeOptionFilter(e.target.value)
                }}
              >
                <MenuItem value={'null'} disabled>เลือกรายการตรวจอื่น ๆ</MenuItem>
                {/* <MenuItem value={'compare-ncds'}>NCDs</MenuItem> */}
                <MenuItem value={'compare-bmi'}>BMI</MenuItem>
                <MenuItem value={'compare-blood-pressure'}>ความดันโลหิต</MenuItem>
                <MenuItem value={'compare-blood-sugar'}>น้ำตาลในเลือด</MenuItem>
                <MenuItem value={'compare-total-cholesterol'}>Total Cholesterol (TC)</MenuItem>
                <MenuItem value={'compare-triglycerides'}>Triglyceride</MenuItem>
                <MenuItem value={'compare-ldl'}>LDL</MenuItem>
                <MenuItem value={'compare-hdl'}>HDL</MenuItem>
                <MenuItem value={'compare-liver'}>การตรวจตับ</MenuItem>
                <MenuItem value={'compare-kidney'}>การตรวจไต</MenuItem>
                <MenuItem value={'compare-x-ray'}>การตรวจ X-RAY</MenuItem>
              </Select>
            </Box>
            {!condition &&
              <Box>
                <Box sx={{ fontWeight: 600 }}>เลือกกลุ่มเสี่ยง (เลือกได้มากกว่า 1)</Box>
                <Select
                  size="small"
                  fullWidth
                  sx={{ ...SelectCss }}
                  multiple
                  value={riskgroup}
                  onChange={(e) => { setRiskgroup(e.target.value) }}
                  renderValue={(selected) => selected.join(', ')}
                >
                  <MenuItem value={''} disabled>เลือกกลุ่มเสี่ยง</MenuItem>
                  {optionRiskgroup.map((i, idx) => (
                    <MenuItem key={idx} value={i}>
                      <Checkbox checked={riskgroup.indexOf(i) > -1} />
                      <ListItemText primary={i} />
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            }
          </Box>

          <Box sx={{
            border: '1px solid #478F96',
            borderRadius: '10px'
          }}>
            <ChartDisease
              ref={chartRef}
              title={compare}
              data={findGraph?.['group_year'] ? findGraph?.['group_year'] : []}
              color={findGraph?.['color'] ? findGraph?.['color'] : null}
            />
          </Box>

          <Box>
            {/* <Button
              variant='contained'
              sx={{
                backgroundColor: '#C8EBEB',
                boxShadow: 'none',
                color: '#263238'
              }}
              onClick={() => handleClickExport('all')}
            >Export raw data</Button> */}
            <Select
              size="small"
              sx={{ ...SelectCss }}
              value={exportData || 'null'}
              onChange={(e) => handleClickExportData(e.target.value, 'all')}
            >
              <MenuItem value={'null'} disabled>Export</MenuItem>
              <MenuItem value={'EXCEL'} >EXCEL</MenuItem>
              <MenuItem value={'PNG'} >PNG</MenuItem>
            </Select>
          </Box>

          <Box sx={{
            overflow: 'auto'
          }}>
            <TableContainer sx={{ maxHeight: '700px' }}>
              <Table sx={{ minWidth: '1200px' }}>
                <TableHead sx={{ backgroundColor: '#C8EBEB' }}>
                  <TableRow>
                    <TableCell align='center' sx={{ minWidth: '220px' }}>ชื่อ-นามสกุล</TableCell>
                    <TableCell align='center' sx={{ minWidth: '180px' }}>เลขบัตรประชาชน</TableCell>
                    <TableCell align='center'>อายุ</TableCell>
                    <TableCell>สังกัด</TableCell>
                    {headerKey.map((key, idx) => (
                      <TableCell key={idx}>{key}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {findDetail.length > 0 ? (
                    findDetail.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell>{item['full_name']}</TableCell>
                        <TableCell align='center'>{item['pid']}</TableCell>
                        <TableCell align='center'>{item['age']}</TableCell>
                        <TableCell>{item['department_name_short']}</TableCell>
                        {headerKey.map((key, idx) => (
                          <TableCell key={idx}>{item[key] && item[key].trim() !== '' ? item[key] : '-'}</TableCell>
                        ))}
                      </TableRow>
                    ))
                  )
                    :
                    (
                      <TableRow>
                        <TableCell colSpan='6'>
                          <Box sx={{ textAlign: 'center' }}>ไม่มีข้อมูล</Box>
                        </TableCell>
                      </TableRow>
                    )
                  }
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          <Box sx={{
            display: 'flex',
            // justifyContent: 'end',
            justifyContent: 'space-between',
            margin: 2
          }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>จำนวนรวม = {totalAll} คน</Typography>
            <Stack spacing={2}>
              <Pagination
                count={maxPage}
                page={page}
                onChange={handlePageChange}
                shape="rounded"
                color="primary"
              />
            </Stack>
          </Box>
        </Box>

      </Box >
    </>
  )
}

export default Index

const SelectCss = {
  backgroundColor: '#C8EBEB',
  border: 'none',
  '.MuiOutlinedInput-notchedOutline': {
    borderColor: '#C8EBEB',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#C8EBEB',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#C8EBEB',
  },
}
